import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'
import DesktopMenuItem from './desktop/MenuItem'
import MobileMenuItem from './mobile/MenuItem'
import MobileBottomMenuItem from './mobile/BottomMenuItem'
import OuterLink from '../../atoms/OuterLink'

const Container = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.palette.border.main};
  border-bottom: ${({ theme }) => `6px solid ${theme.palette.primary.main}`};
  padding: 0 0 30px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    border-bottom: ${({ theme }) => `20px solid ${theme.palette.primary.main}`};
    display: flex;
    justify-content: center;
    padding: 50px 380px;
  }
`

const AppInfo = styled.div`
  margin: 0 auto;
  padding: 30px 0 25px;
  width: 200px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0;
    padding: 10px 0 0;
    width: 275px;
  }
`

const StoreButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 35px 0 0;
  }
`

const StoreLink = styled(OuterLink)<{ width: string }>`
  display: inline-block;
  margin-left: 8px;
  text-decoration: none;
  width: ${({ width }) => width};
  &:first-child {
    margin: 0;
  }
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: calc(${({ width }) => width} * 1.33);
  }
`

const Menu = styled.ul`
  list-style: none;
  padding: 0;
`

const DesktopMenuContainer = styled.div`
  border-left: 1px solid ${({ theme }) => theme.palette.border.main};
  box-sizing: border-box;
  margin-left: 50px;
  padding: 10px 0 10px 20px;
  width: 200px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const DesktopMenuTitle = styled.p`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 16px;
`

const DesktopMenu = styled(Menu)`
  margin: 20px 0 0;
`

const MobileMenu = styled(Menu)`
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

const MobileBottomMenu = styled.ul`
  display: flex;
  flex-wrap: wrap;
  height: 1em;
  justify-content: center;
  list-style: none;
  margin: 26px auto 32px;
  padding: 0;
  width: 80vw;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

export default function Footer() {
  return (
    <Container>
      <AppInfo>
        <Image filename="logo-mamari.png" />
        <StoreButtonGroup>
          <StoreLink width="100px" to="https://app.adjust.com/5sq667p">
            <Image filename="google-play.png" />
          </StoreLink>
          <StoreLink width="82px" to="https://app.adjust.com/nrfd83w">
            <Image filename="app-store.png" />
          </StoreLink>
        </StoreButtonGroup>
      </AppInfo>
      {/* Desktop */}
      <DesktopMenuContainer>
        <DesktopMenuTitle>ママリについて</DesktopMenuTitle>
        <DesktopMenu>
          <DesktopMenuItem text="ママリトップ" to="https://mamari.jp" />
          <DesktopMenuItem text="Twitter" to="https://twitter.com/mamari_official" />
          <DesktopMenuItem text="Instagram" to="https://www.instagram.com/mamari_official/" />
          <DesktopMenuItem text="Facebook" to="https://www.facebook.com/mamarijp/" />
        </DesktopMenu>
      </DesktopMenuContainer>
      <DesktopMenuContainer>
        <DesktopMenuTitle>当サイトについて</DesktopMenuTitle>
        <DesktopMenu>
          <DesktopMenuItem text="利用規約" to="https://mamari.jp/terms" />
          <DesktopMenuItem text="プライバシーポリシー" to="https://mamari.jp/privacy" />
          <DesktopMenuItem text="お問い合わせ" to="https://bit.ly/2Upl4AD" />
          <DesktopMenuItem text="企業の皆様へ" to="/about" />
          <DesktopMenuItem text="運営会社" to="https://connehito.com" />
        </DesktopMenu>
      </DesktopMenuContainer>

      {/* Mobile */}
      <MobileMenu>
        <MobileMenuItem text="ママリトップ" to="https://mamari.jp" />
        <MobileMenuItem text="Twitter" to="https://twitter.com/mamari_official" />
        <MobileMenuItem text="Instagram" to="https://www.instagram.com/mamari_official/" />
        <MobileMenuItem text="Facebook" to="https://www.facebook.com/mamarijp/" />
      </MobileMenu>
      <MobileBottomMenu>
        <MobileBottomMenuItem text="利用規約" to="https://mamari.jp/terms" />
        <MobileBottomMenuItem text="プライバシーポリシー" to="https://mamari.jp/privacy" />
        <MobileBottomMenuItem text="お問い合わせ" to="https://bit.ly/2Upl4AD" />
        <MobileBottomMenuItem text="企業の皆様へ" to="/about" />
        <MobileBottomMenuItem text="運営会社" to="https://connehito.com" />
      </MobileBottomMenu>
    </Container>
  )
}
